import * as yup from 'yup';

export const lenderOrderContactFormValidation = () =>
  yup.object({
    firstName: yup.string().nullable().required(),
    middleName: yup.string().nullable(),
    lastName: yup.string().nullable().required(),
    email: yup.string().email().nullable().required(),
    phoneNumber: yup.string().nullable(),
    functions: yup.array().of(yup.string()).min(1).nullable().required(),
  });
